import { render, staticRenderFns } from "./FormPayment.vue?vue&type=template&id=1b5fc788"
import script from "./FormPayment.vue?vue&type=script&lang=js"
export * from "./FormPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports